import styled from 'styled-components'
import Button from 'components/Button'
import CommentForm from '../CallControls/CommentForm'
import ThumbsButton from '../CallControls/ThumbsButton'

const Wrapper = styled.div`
  position: relative;
  height: 65px;
  margin-top: 35px;
  margin-bottom: 20px;
`

const Container = styled.div`
  max-width: 350px;
  white-space: nowrap;
  position: absolute;
  right: 20px;
  border-radius: 5px;
  z-index: 100;
  box-shadow: 10px 10px 64px 0px rgba(0, 0, 0, 0.15);
  border: 1px solid var(--light-gray);
  background: var(--white);
  margin-bottom: 50px;

  @media only screen and (max-width: 768px) {
    right: -4%;
    left: -7%;
  }
`

const Title = styled.div`
  font-size: 16px;
  float: left;
  line-height: 33px;
`
const Content = styled.div`
  padding: 15px;
`

const Buttons = styled.div`
  text-align: right;
  float: right;
`

const StyledButton = styled(ThumbsButton)`
  color: var(--gray);
  border-color: var(--gray);

  &:hover {
    border-color: var(--main-color);
    color: var(--main-color);
  }
`

const SubmitButton = styled(Button)`
  background: var(--main-color);
  color: var(--white);
  border-color: var(--main-color);
  float: right;
  margin-left: 28px;

  &:hover {
    color: var(--white);
  }
`
const Heading = styled.h5`
  margin: 9px 0px 0px 18px;
  float: right;
  font-weight: 700;
  color: var(--main-color);
  &:hover {
    color: var(--main-color);
  }
`

/**
 * The `FeedbackBlock` component is responsible for rendering the feedback UI
 * for an article. It displays a title, buttons for upvoting or downvoting the
 * article, and an optional submit button and comment form.
 * The component's behavior is controlled by the props passed to it.
 *
 * @param {Object} props - The props object containing the following properties:
 * @param {Function} props.handleClick - A function that handles the click event
 * @param {Boolean} props.feedbackEnabled - A boolean value indicating whether
 *    the feedback feature is enabled or not
 * @param {Function} props.handleChange - A function that handles the change
 *    event
 * @param {Boolean} props.showForm - A boolean value indicating whether the form
 *    is visible or not
 * @param {Boolean} props.resolved - A boolean value indicating whether the
 *    feedback has been resolved or not
 * @param {Function} props.handleSubmit - A function that handles the submit event
 * @returns {JSX.Element} - The rendered JSX element representing the feedback block
 */
const FeedbackBlock = ({
  handleClick,
  feedbackEnabled,
  handleChange,
  showForm,
  resolved,
  handleSubmit
}) => (
  <Wrapper>
    <Container className={showForm ? 'expanded' : ''}>
      <Content className="clearfix">
        <Title>
          {feedbackEnabled && <>Article Helpful?</>}
          {!feedbackEnabled && <>Thank you for the feedback</>}
        </Title>

        <Buttons>
          {feedbackEnabled && (
            <>
              <StyledButton
                active={resolved === true}
                direction="up"
                handleClick={handleClick.bind(this, true)}
              />
              <StyledButton
                active={resolved === false}
                direction="down"
                handleClick={handleClick.bind(this, false)}
              />
            </>
          )}
          {showForm && (
            <SubmitButton onClick={handleSubmit}>Submit</SubmitButton>
          )}

          {!showForm && <Heading>Feedback</Heading>}
        </Buttons>
      </Content>

      {showForm && <CommentForm handleChange={handleChange} />}
    </Container>
  </Wrapper>
)

export default FeedbackBlock
